import { createRouter, createWebHistory } from "vue-router"
import MainLayout from "@/layouts/index.vue"

const routes = [

    { path: '/', redirect: '/login' },
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/auth/LoginPage.vue")
    },
    {
        path: "/preview/:id",
        name: "preview",
        component: () => import("@/views/preview/photos.vue")
    },

    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: "/dashboard",
                name: "dashboard",
                component: () => import("@/views/dashboard/index.vue"),
                meta: { requiresAuth: true }
            },
            {
                path: "/users",
                name: "users",
                component: () => import("@/views/users/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "/outlets",
                name: "outlets",
                component: () => import("@/views/outlets/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "booths",
                name: "booths",
                component: () => import("@/views/booths/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "plans",
                name: "plans",
                component: () => import("@/views/plans/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "addons",
                name: "addons",
                component: () => import("@/views/addons/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "frames",
                name: "frames",
                component: () => import("@/views/frames/frames.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "vouchers",
                name: "vouchers",
                component: () => import("@/views/vouchers/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "templates",
                name: "templates",
                component: () => import("@/views/templates/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "customers",
                name: "customers",
                component: () => import("@/views/customers/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "photos",
                name: "photos",
                component: () => import("@/views/photos/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "dirs",
                name: "dirs",
                component: () => import("@/views/photos/dirs.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "/dir/:id",
                name: "dir",
                component: () => import("@/views/photos/upload-photos.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "transactions",
                name: "transactions",
                component: () => import("@/views/transactions/index.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "create-transaction",
                name: "create-transaction",
                component: () => import("@/views/transactions/create-transaction.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "report-revenues",
                name: "report-revenues",
                component: () => import("@/views/reports/revenues.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "report-revenues-by-method",
                name: "report-revenues-by-method",
                component: () => import("@/views/reports/revenue-by-method.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },
            {
                path: "report-packages",
                name: "report-packages",
                component: () => import("@/views/reports/plans.vue"),
                meta: { hideFooter: true, requiresAuth: true },  // Footer is hidden
            },

        ],
    },

    {
        path: "/:pathMatch(.*)*",
        name: "page_404",
        component: () => import("@/layouts/Page404.vue")
    },

]
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
})


router.beforeEach((to, from, next) => {
    const accessToken = localStorage.getItem("accessToken")

    if (accessToken) {
        // console.log(accessToken)        
        if (to.path === "/" || to.path === "/login") {
            return next("/dashboard")
        }
    } else {
        // Jika tidak ada accessToken dan halaman membutuhkan autentikasi, redirect ke login
        if (to.meta.requiresAuth) {
            return next("/login")
        }
    }

    next()
})


export default router